import { readOnboardingCompleted } from "./onboardingStorage";
import { ensureOnboardingImagesPreloaded } from "./onboardingImagePreload";

/** Start onboarding illustration preload before React paints the flow. */
if (!readOnboardingCompleted()) {
  void ensureOnboardingImagesPreloaded();
}
